import React, { useState, useEffect } from 'react';
import { Row, Col, Form, Button, Card, Container } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { subDays, subYears, addYears } from 'date-fns';
import 'react-datepicker/dist/react-datepicker.css';
import '../../assets/styles/DateRangePicker.css'; // 假设你有一个自定义样式文件

const DateRangePicker = ({
  startDate: initialStartDate,
  endDate: initialEndDate,
  onChange,
  maxDate = addYears(new Date(), 2),
  minDate = subYears(new Date(), 1)
}) => {
  const [dateRange, setDateRange] = useState([
    initialStartDate || null,
    initialEndDate || null
  ]);
  const [startDate, endDate] = dateRange;

  const handleDateChange = (update) => {
    setDateRange(update);
    const [start, end] = update;

    // 仅当选择了完整的范围（起始和结束）时才回调
    if (start && end && onChange) {
      onChange({ startDate: start, endDate: end });
    }
  };

  // ✅ 关键修复：监听 props 改变同步内部 state
  useEffect(() => {
    if (
      (initialStartDate && !startDate) ||
      (initialEndDate && !endDate) ||
      (initialStartDate && startDate && +initialStartDate !== +startDate) ||
      (initialEndDate && endDate && +initialEndDate !== +endDate)
    ) {
      setDateRange([initialStartDate, initialEndDate]);
    }
  }, [initialStartDate, initialEndDate]);

  return (
    <DatePicker
      selectsRange
      startDate={startDate}
      endDate={endDate}
      onChange={handleDateChange}
      minDate={minDate}
      maxDate={maxDate}
      placeholderText="Select start and end dates"
      className="form-control datepicker-custome"
      popperClassName="datepicker-popper"

      showPopperArrow={false}   // ← 隐藏默认小箭头
      openToDate={startDate}
      dropdownMode="select"
      renderCustomHeader={({
        date,
        changeYear,
        changeMonth,
        decreaseMonth,
        increaseMonth,
        prevMonthButtonDisabled,
        nextMonthButtonDisabled
      }) => {
        // 生成年份范围（当前年前后10年）
        const years = Array.from({ length: 4 }, (_, i) => new Date().getFullYear() - 1 + i);
        const months = Array.from({ length: 12 }, (_, i) =>
          new Date(0, i).toLocaleString('default', { month: 'short' })
        );

        return (
          <div className="custom-header d-flex justify-content-between align-items-center px-2 py-2">
            <button
              className="btn btn-sm btn-light rounded"
              onClick={decreaseMonth}
              disabled={prevMonthButtonDisabled}
            >
              ‹
            </button>

            <div className="d-flex align-items-center gap-2">
              <div className="year-select">
                <select
                  className="form-select form-select-sm"
                  value={date.getFullYear()}
                  onChange={(e) => changeYear(Number(e.target.value))}
                >
                  {years.map((year) => (
                    <option key={year} value={year}>{year}</option>
                  ))}
                </select>
              </div>

              <div className="month-select">
                <select
                  className="form-select form-select-sm"
                  value={date.getMonth()}
                  onChange={(e) => changeMonth(Number(e.target.value))}
                >
                  {months.map((month, index) => (
                    <option key={index} value={index}>{month}</option>
                  ))}
                </select>
              </div>
            </div>

            <button
              className="btn btn-sm btn-light rounded"
              onClick={increaseMonth}
              disabled={nextMonthButtonDisabled}
            >
              ›
            </button>
          </div>
        );
      }}
    />

  );
};

export default DateRangePicker;